import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=8e53f0dc&"
import script from "./TagIcon.vue?vue&type=script&lang=js&"
export * from "./TagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports